import { render, staticRenderFns } from "./SettingsDonation.vue?vue&type=template&id=225d2bea&"
import script from "./SettingsDonation.vue?vue&type=script&lang=js&"
export * from "./SettingsDonation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports